/* eslint-disable no-unused-vars */
import { React, useState, useEffect, useContext } from 'react';
import InputMask from 'react-input-mask';

import 'src/App.scss';
import './style.scss';

import Logo from 'src/assets/base/logoNewte.jpg';

import cooCafeLogo from 'src/assets/logos/coocafe.png';
import emfloraLogo from 'src/assets/logos/emflora.png';
import equilibrioLogo from 'src/assets/logos/equilibrio.png';
import nooaLogo from 'src/assets/logos/nooa.png';
import tpjLogo from 'src/assets/logos/tpj.png';
import vixPortLogo from 'src/assets/logos/vixport.png';
import nicchioLogo from 'src/assets/logos/nichio.png';
import tvparanaibaLogo from 'src/assets/logos/tvparanaiba.png';
import xamegobomLogo from 'src/assets/logos/xamegobom.png';
import sorvedocesLogo from 'src/assets/logos/sorvedoces.png';
import ceresLogo from 'src/assets/logos/ceresAlt.png';
import DefIcon from 'src/assets/base/page.svg';

import Load from 'src/assets/base/Load.gif';
import { LoadGif } from 'src/components';

import { LogContext } from 'src/components/LogProvider';
import { showToast } from 'src/components';

import axios from 'axios';
import { Margin } from '@mui/icons-material';
import { GetLogin, GetPermissoes, isValid } from 'src/services/auth';
import { GetIdentifier } from 'src/components/assinatura/auth';

function Entrar() {
  const getIdentificador = GetIdentifier();
  console.log('a', getIdentificador);
  const [status, setStatus] = useState('');
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');

  const { setLogData } = useContext(LogContext);

  const logoList = {
    'coocafe.newlink.app.br': cooCafeLogo,
    'emflora.newlink.app.br': emfloraLogo,
    'equilibrio.newlink.app.br': equilibrioLogo,
    'nooa.newlink.app.br': nooaLogo,
    'tpj.newlink.app.br': tpjLogo,
    'vixport.newlink.app.br': vixPortLogo,
    'nicchio.newlink.app.br': nicchioLogo,
    'tvparanaiba.newlink.app.br': tvparanaibaLogo,
    'xamegobom.newlink.app.br': xamegobomLogo,
    'sorvedoces.newlink.app.br': sorvedocesLogo,
    'ceres.newlink.app.br': ceresLogo,
  };

  const [newId, setNewId] = useState(
    getIdentificador === 'localhost' ? '' : null
  );

  const [errorMsg, setErrorMsg] = useState('');

  const onSubmit = async (cpf, password) => {
    setErrorMsg('');
    setStatus('load');

    const formattedCpf = cpf.replace(/\D/g, '');

    if (!isValid(cpf)) {
      setErrorMsg('Usuário não preenchido');
      setStatus('');
      return;
    }
    if (!isValid(password)) {
      setErrorMsg('Senha não preenchida');
      setStatus('');
      return;
    }

    try {
      await GetLogin(cpf, password, setLogData, newId);
      await GetPermissoes();
      setTimeout(() => {
        setStatus('');
      }, 1000);
    } catch (error) {
      setStatus('');
      setErrorMsg(
        error.message.replace(
          /^\[EMVCException\] Erro na autentificacao:\s*/,
          ''
        )
      );
    }
  };

  useEffect(() => {
    setCpf('');
    setPassword('');
    setStatus('');
  }, []);

  return (
    <form
      onSubmit={(e) => {
        onSubmit(cpf, password);
        e.preventDefault();
      }}
      className={`entrar ${status}`}
    >
      {status === 'load' && <LoadGif />}

      <img
        src={logoList[getIdentificador] ? logoList[getIdentificador] : Logo}
        onError={(e) => {
          e.currentTarget.src = DefIcon;
        }}
      />

      <h1 className="mainTitle"> Login </h1>

      <span className="errorMsg">{status != 'load' && errorMsg}</span>

      {/*(
        <input
          placeholder="newId"
          value={newId}
          onChange={(e) => setNewId(e.target.value)}
          className="mainInput"
        />
      )*/}
      <label> Usuário </label>
      <input
        value={cpf}
        onChange={(e) => setCpf(e.target.value.trim())}
        className="mainInput"
      />
      <label> Senha </label>
      <InputMask
        className="mainInput"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value.trim())}
      />
      <a>
        <span />
      </a>
      {/*<a href={'/recuperarsenha'}>
        <span> Esqueci minha senha </span>
      </a>*/}

      <button type="submit" className={`mainSubmit`}>
        Entrar
      </button>
    </form>
  );
}

export default Entrar;
